import { render, staticRenderFns } from "./HomeSmallBanner.vue?vue&type=template&id=2cf107d0&scoped=true"
import script from "./HomeSmallBanner.vue?vue&type=script&lang=js"
export * from "./HomeSmallBanner.vue?vue&type=script&lang=js"
import style0 from "./HomeSmallBanner.vue?vue&type=style&index=0&id=2cf107d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf107d0",
  null
  
)

export default component.exports